export default __webpack_public_path__ + "static/media/body.50f33143.png";